import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.gray.dark,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(3.5, 3.5, 5.875, 3.5),
  },
  typographyContainer: {
    backgroundColor: theme.palette.gray.dark,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2.5),
    marginTop: theme.spacing(2),
  },
  tileContainer: {
    marginTop: theme.spacing(2),
  },
  sendIcon: {
    width: theme.spacing(9.375),
    height: theme.spacing(4.75),
    marginRight: theme.spacing(2),
  },
  labelSubtitle: {
    marginLeft: theme.spacing(4),
    fontSize: theme.typography.h5.fontSize,
    color: theme.palette.text.secondary,
  },
}));
